import React, { lazy, Suspense, useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import "../ContactUs/Contactus.css";
import { Container, Row, Button, Col } from "react-bootstrap";
import content from '../content.json';
import parse from 'html-react-parser';
import Error from '../error/ErrorPage';
import Header from "../Header/index";
import Body from "../Body/Body";
import Contactus from "../ContactUs/Contactus";
import ReadyToChase from '../Unwrap/unwrap';
import FeatureSection from '../Features/features';
// import Footer from '../CommenFooterComponent/index';
import axios from "axios";

const Footer = lazy(() => import("../CommenFooterComponent/index"));

function LOPage() {
  const [dataJson, setDataJson] = useState(null);
  const [loInfo, setLoInfo] = useState(null);
  const [loanOfficerUid, setLoanOfficerUid] = useState('');
  const { loName, agentName } = useParams();
  const agentJsonName = agentName ? agentName.toLowerCase() + ".json" : null;
  const [loading, setLoading] = useState(true);
  const [loadBodyData, setLoadBodyData] = useState(true);
  const [agentData, setAgentData] = useState();
  const [loanOfficerActive, setLoanOfficerActive] = useState(true);
  const [loanOfficerData, setLoanOfficerData] = useState();
  const [realtorData, setRealtorData] = useState();
  const [aiBrandingData, setAiBrandingData] = useState();
  const [angelAiUserInfo, setAngelAiUserInfo] = useState();
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const timestamp = Date.now();
        const response = await fetch(`${process.env.REACT_APP_RENOVATION_PROGRAM_JSON}?timestamp=${timestamp}`);
        const jsonData = await response.json();
        setDataJson(jsonData);
      } catch (error) {
        console.error('Error fetching links:', error);
        setDataJson(content); // Use local JSON data if fetching fails
      }
    };

    if (!dataJson) {
      fetchData(); // Fetch JSON only if the links data is not available
    }
  }, [dataJson]);

  useEffect(() => {
    if (!dataJson) {
      setDataJson(content); // Set local JSON data as fallback initially
    }
  }, []);

  useEffect(() => {
    const fetchAiBrandingJson = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_ANGELAI_JSON)
          .then((response) => {
            setAiBrandingData(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    const fetchAngelAiUserInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_ANGEL_AI_WEB_USER_INFO)
          .then((response) => {
            setAngelAiUserInfo(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    const checkifLoanOfficerIsActive = async (loanOfficerId) => {
      try {
        await axios
          .post(process.env.REACT_APP_CHECK_LO_ACTIVE, {
            loanOfficerId: loanOfficerId,
          })
          .then((response) => {
            setLoanOfficerActive(response.data.active);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    const fetchAgentDetails = async () => {
      try {
        await axios
          .get(
            process.env.REACT_APP_CDN +
            "swmc/jsons/loanOfficer/loanOfficerJson/" +
            agentJsonName
          )
          .then(async (response) => {
            const responseData = response.data;
            console.log("Response Data:", responseData);
            setAgentData(responseData);
            await fetchAiBrandingJson();
            if (responseData) {
              setLoading(false);
              const loanOfficerId = responseData.loanOfficer.ssid;
              console.log("loanOfficerId Data:", loanOfficerId);
              await checkifLoanOfficerIsActive(loanOfficerId);
              await fetchAngelAiUserInfo();
              setLoanOfficerData(responseData.loanOfficer);
              setRealtorData(responseData.realtor);
              setLoadBodyData(false);
            }
          })
          .catch((error) => {
            console.log("Error fetching agent details:", error);
            // Redirect to homepage if fetching fails
            window.location.replace('http://www.swmc.com');
          });
      } catch (e) {
        console.log(e);
        // Redirect to homepage if fetching fails
        window.location.replace('http://www.swmc.com');
      }
    };

    if (agentJsonName) {
      fetchAgentDetails();
    } else {
      // Redirect to homepage if agentJsonName is not present
      window.location.replace('http://www.swmc.com');
    }
  }, [agentJsonName]);

  return (
    <div>
      {dataJson ? (
        <>
          <Header fetchpriority="high" />
          <Body fetchpriority="high" dataJson={dataJson.body} />
          <Suspense fallback={<div />}>
            <ReadyToChase
              dataJson={dataJson.unwrap}
              realtorData={realtorData}
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
          </Suspense>
          <Suspense fallback={<div />}>
            <FeatureSection
              dataJson={dataJson.feature}
              dataJsonnew={dataJson.tableData}
              realtorData={realtorData}
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
          </Suspense>
          <Contactus
            dataJson={dataJson.disclaimer}
            realtorData={realtorData}
            loanOfficerActive={loanOfficerActive}
            loanOfficerData={loanOfficerData}
            angelAiUserInfo={angelAiUserInfo}
          />
          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
        </>
      ) : (
        <div className='loading'>Loading...</div>
      )}
    </div>
  );
}

export default LOPage;
